const REQ_DATA = {
  UPDATE_USERS_REQ_DATA: 'UPDATE_USERS_REQ_DATA',
  UPDATE_ORDERS_REQ_DATA: 'UPDATE_ORDERS_REQ_DATA',
  UPDATE_LULU_ORDERS_REQ_DATA: 'UPDATE_LULU_ORDERS_REQ_DATA',
  UPDATE_GOMS_ORDERS_REQ_DATA: 'UPDATE_GOMS_ORDERS_REQ_DATA',
  UPDATE_ACTIVE_SEARCH: 'UPDATE_ACTIVE_SEARCH',
  UPDATE_ACTIVE_LULU_ORDERS_TAB: 'UPDATE_ACTIVE_LULU_ORDERS_TAB',
  UPDATE_ACTIVE_KYC_USERS_FUNNEL: 'UPDATE_ACTIVE_KYC_USERS_FUNNEL',
  UPDATE_LULU_FUNNEL_ORDERS_REQ_DATA: 'UPDATE_LULU_FUNNEL_ORDERS_REQ_DATA',
  UPDATE_FUNNEL_USERS_REQ_DATA: 'UPDATE_FUNNEL_USERS_REQ_DATA',
  UPDATE_CAMPAIGNS_REQ_DATA: 'UPDATE_CAMPAIGNS_REQ_DATA',
  UPDATE_NR_USERS_REQ_DATA: 'UPDATE_NR_USERS_REQ_DATA',
  UPDATE_PROVIDER_HOLIDAYS_REQ_DATA: 'UPDATE_PROVIDER_HOLIDAYS_REQ_DATA',
  UPDATE_KYC_CHECKS_REQ_DATA: 'UPDATE_KYC_CHECKS_REQ_DATA',
  UPDATE_ALL_KYCS_REQ_DATA: 'UPDATE_ALL_KYCS_REQ_DATA',
  UPDATE_USER_KYC_TIERS_REQ_DATA: 'UPDATE_USER_KYC_TIERS_REQ_DATA',

  UPDATE_USER_TRANSFERS_REQ_DATA: 'UPDATE_USER_TRANSFERS_REQ_DATA',
  UPDATE_USER_BBPS_ORDERS_REQ_DATA: 'UPDATE_USER_BBPS_ORDERS_REQ_DATA',
  UPDATE_USER_REFERRAL_REQ_DATA: 'UPDATE_USER_REFERRAL_REQ_DATA',
  UPDATE_USER_SIPS_REQ_DATA: 'UPDATE_USER_SIPS_REQ_DATA',

  UPDATE_BBPS_COMPLAINTS_REQ_DATA: 'UPDATE_BBPS_COMPLAINTS_REQ_DATA',

  UPDATE_THUNES_ORDERS_REQ_DATA: 'UPDATE_THUNES_ORDERS_REQ_DATA',
  UPDATE_THUNES_FULFILLMENTS_REQ_DATA: 'UPDATE_THUNES_FULFILLMENTS_REQ_DATA',

  UPDATE_SOURCE_ACCOUNTS_REQ_DATA: 'UPDATE_SOURCE_ACCOUNTS_REQ_DATA',

  UPDATE_JOBS_REQ_DATA: 'UPDATE_JOBS_REQ_DATA',

  UPDATE_REDEEMED_COINS_REQ_DATA: 'UPDATE_REDEEMED_COINS_REQ_DATA',
  UPDATE_USER_REDEEMED_COINS_REQ_DATA: 'UPDATE_USER_REDEEMED_COINS_REQ_DATA',

  UPDATE_FUNNEL_V2_REQ_DATA: 'UPDATE_FUNNEL_V2_REQ_DATA',
  UPDATE_FUNNEL_V2_ORDERS_REQ_DATA: 'UPDATE_FUNNEL_V2_ORDERS_REQ_DATA',
  
  UPDATE_GOMS_FUNNEL_REQ_DATA: 'UPDATE_GOMS_FUNNEL_REQ_DATA',
  UPDATE_GOMS_FUNNEL_ORDERS_REQ_DATA: 'UPDATE_GOMS_FUNNEL_ORDERS_REQ_DATA',

  UPDATE_TICKETS_REQ_DATA: 'UPDATE_TICKETS_REQ_DATA',
  /* nronboard states */
  // UPDATE_NROB_ACTIVE_FUNNEL: 'UPDATE_NROB_ACTIVE_FUNNEL',
  // UPDATE_NROB_QUERY: 'UPDATE_NROB_QUERY'
  UPDATE_NROB_REQ_DATA: 'UPDATE_NROB_REQ_DATA',
  UPDATE_USER_SOURCE_ACCOUNTS_REQ_DATA: 'UPDATE_USER_SOURCE_ACCOUNTS_REQ_DATA',

  UPDATE_RDA_REQ_DATA: 'UPDATE_RDA_REQ_DATA',
  UPDATE_VANCE_CASH_REQ_DATA: 'UPDATE_VANCE_CASH_REQ_DATA',
  UPDATE_VDA_FUNNEL_REQ_DATA: 'UPDATE_VDA_FUNNEL_REQ_DATA',
  UPDATE_PENDING_ORDER_RECEIPTS_REQ_DATA:
    'UPDATE_PENDING_ORDER_RECEIPTS_REQ_DATA',
  UPDATE_REWARDS_REQ_DATA: 'UPDATE_REWARDS_REQ_DATA',
  UPDATE_BAERSCREST_OPS_REQ_DATA: 'UPDATE_BAERSCREST_OPS_REQ_DATA',
  UPDATE_RDA_DASHBOARD_REQ_DATA: 'UPDATE_RDA_DASHBOARD_REQ_DATA',

  UPDATE_FALCON_CLIENT_REQ_DATA: 'UPDATE_FALCON_CLIENT_REQ_DATA',
  UPDATE_FALCON_TRANSACTIONS_REQ_DATA: 'UPDATE_FALCON_TRANSACTIONS_REQ_DATA',
  UPDATE_FALCON_VENDOR_REQ_DATA: 'UPDATE_FALCON_VENDOR_REQ_DATA',
  UPDATE_FALCON_RFI_TRANSACTIONS_REQ_DATA: 'UPDATE_FALCON_RFI_TRANSACTIONS_REQ_DATA',
  UPDATE_FALCON_ANALYTICS_REQ_DATA:'UPDATE_FALCON_ANALYTICS_REQ_DATA', 

// Constants for updating the req data state of Beneficiary verification dashboard
  UPDATE_BENEFICIARY_VERIFICATION_REQ_DATA: 'UPDATE_BENEFICIARY_VERIFICATION_REQ_DATA',

// Constants for lulu order refund dashboard
  UPDATE_LULU_ORDER_REFUND_REQ_DATA: 'UPDATE_LULU_ORDER_REFUND_REQ_DATA',

// Constants for recon dashboard
  UPDATE_RECON_DEPOSIT_REQ_DATA: 'UPDATE_RECON_DEPOSIT_REQ_DATA',

// constant for settlement timeline manaager
  UPDATE_GLOBAL_SETTLEMENT_TIMELINE_REQ_DATA: 'UPDATE_GLOBAL_SETTLEMENT_TIMELINE_REQ_DATA',
  UPDATE_RFI_SETTLEMENT_TIMELINE_REQ_DATA: 'UPDATE_RFI_SETTLEMENT_TIMELINE_REQ_DATA',
  UPDATE_FULFILLMENT_SETTLEMENT_TIMELINE_REQ_DATA: 'UPDATE_FULFILLMENT_SETTLEMENT_TIMELINE_REQ_DATA',
  UPDATE_PAYMENT_SETTLEMENT_TIMELINE_REQ_DATA: 'UPDATE_PAYMENT_SETTLEMENT_TIMELINE_REQ_DATA',

// constant for settlement service dashboard
  UPDATE_SETTLEMENT_SERVICE_CLIENTS_REQ_DATA: 'UPDATE_SETTLEMENT_SERVICE_CLIENTS_REQ_DATA',
  UPDATE_SETTLEMENT_SERVICE_LEDGERS_REQ_DATA: 'UPDATE_SETTLEMENT_SERVICE_LEDGERS_REQ_DATA',
  UPDATE_SETTLEMENT_SERVICE_ACCOUNTS_REQ_DATA: 'UPDATE_SETTLEMENT_SERVICE_ACCOUNTS_REQ_DATA',
  UPDATE_SETTLEMENT_SERVICE_ACCOUNT_TRANSACTIONS_REQ_DATA: 'UPDATE_SETTLEMENT_SERVICE_ACCOUNT_TRANSACTIONS_REQ_DATA',
  UPDATE_SETTLEMENT_SERVICE_LEDGER_STATEMENT_REQ_DATA: 'UPDATE_SETTLEMENT_SERVICE_LEDGER_STATEMENT_REQ_DATA',

// constant for updating the workflow docs
  UPDATE_WORKFLOW_DOCS_REQ_DATA: 'UPDATE_WORKFLOW_DOCS_REQ_DATA',

// constant for sardine on hold orders
  UPDATE_SARDINE_ON_HOLD_REQ_DATA: 'UPDATE_SARDINE_ON_HOLD_REQ_DATA',
  UPDATE_GOMS_FULFILLMENT_REQ_DATA: 'UPDATE_GOMS_FULFILLMENT_REQ_DATA',

  // Case Investigation Manager Constant
  UPDATE_FALCON_CASE_INVESTIGATION_MANAGER_REQ_DATA: 'UPDATE_FALCON_CASE_INVESTIGATION_MANAGER_REQ_DATA',

// constant for outbound calling dashboard
  UPDATE_OUTBOUND_CALLING_TICKETS_REQ_DATA: 'UPDATE_OUTBOUND_CALLING_TICKETS_REQ_DATA',

// constants for Libra Dashboard
  UPDATE_LIBRA_ACCOUNTS_REQ_DATA: 'UPDATE_LIBRA_ACCOUNTS_REQ_DATA',
  UPDATE_LIBRA_TRANSFERS_REQ_DATA: 'UPDATE_LIBRA_TRANSFERS_REQ_DATA',
  UPDATE_LIBRA_CORPORATE_BENEFICIARIES_REQ_DATA: 'UPDATE_LIBRA_CORPORATE_BENEFICIARIES_REQ_DATA',
  UPDATE_LIBRA_SCHEDULED_TRANSFERS_REQ_DATA: 'UPDATE_LIBRA_SCHEDULED_TRANSFERS_REQ_DATA',

  // constants for Fast Transfer Manager
  UPDATE_FAST_TRANSFER_MANAGER_REQ_DATA: 'UPDATE_FAST_TRANSFER_MANAGER_REQ_DATA'
};

export default REQ_DATA;
